<template>
  <div>
    <!-- Seconda CTA Live Market da pagina nominale -->
    <div class="button-container" v-if="type === 'nominale' && liveMarketExists">
      <div class="prize-text">{{ liveMarketText || 'REPORT LIVE MARKET' }}</div>
      <div v-if="liveMarketDescription" class="mr-45">
        <small class="fs-14" v-html="liveMarketDescription"></small>
      </div>
      <button
        class="button-primary wtevent"
        :disabled="loadingLiveMarket"
        @click="onLiveMarketClick"
        data-event-click="quotamoto.nominale.live-market.click"
        data-event-imps="quotamoto.nominale.live-market.imps"
        ref="liveMarketButton"
      >
        <template v-if="!loadingLiveMarket">
          <span>ACQUISTA A </span>
          <span :class="promotions['live-market'] && promotions['live-market'].new ? 'line-through' : ''">
            {{ promotions['live-market'] ? promotions['live-market'].standard : '' }}€
          </span>
          <span v-if="promotions['live-market'] && promotions['live-market'].new">
            {{ promotions['live-market'].new }}€
          </span>
        </template>
        <loader v-else size="20px" />
      </button>
    </div>

    <div
      class="button-container"
      :class="{ 'button-container--compact-price': compactPriceLayout }"
    >
      <template v-if="compactPriceLayout">
        <div v-if="showPrice" class="prize-text prize-text--prezzo">
          <span class="prezzo-prefix">Prezzo:</span>
          <span :class="promotions[type].new ? 'line-through' : ''">
            {{ promotions[type].standard }}€
          </span>
          <span v-if="promotions[type].new" class="prezzo-promo">
            {{ promotions[type].new }}€
          </span>
        </div>
        <div v-else class="prize-text prize-text--prezzo"></div>
      </template>
      <template v-else>
        <div v-if="price" class="prize-text">
          {{ price }}
        </div>
      </template>
      <div v-if="ctaDescription && !compactPriceLayout" class="mr-45">
        <small class="fs-14" v-html="ctaDescription"></small>
      </div>
      <button
        :class="[
          {
            'button-buy-nominal': type === 'nominale',
            'button-primary': type !== 'nominale',
            disabledBtn: type === 'storica' && !isDateValid,
          },
          'wtevent',
          loadingMain ? 'bg-primary' : '',
        ]"
        :disabled="loadingMain"
        @click="onMainClick"
        :data-event-click="`quotamoto.${type}.click`"
        :data-event-imps="`quotamoto.${type}.imps`"
        ref="mainButton"
      >
        <template v-if="!loadingMain">
          <span>{{ mainButtonLabel }}</span>
          <template v-if="showPrice && !compactPriceLayout">
            <span :class="promotions[type].new ? 'line-through' : ''">
              {{ promotions[type].standard }}€
            </span>
            <span v-if="promotions[type].new">
              {{ promotions[type].new }}€
            </span>
          </template>
        </template>
        <loader v-else size="20px" />
      </button>
    </div>
  </div>
</template>

<script>
import Loader from './Loader.vue';

export default {
  name: 'BuyQuotationBtn',
  components: { Loader },
  props: {
    type: { type: String, required: true },
    promotions: { type: Object, default: () => ({}) },
    liveMarketExists: { type: Boolean, required: true },
    acquistoCta: { type: Object, default: () => ({}) },
    isDateValid: { type: Boolean, default: false },
  },
  data() {
    return {
      loadingMain: false,
      loadingLiveMarket: false,
    };
  },
  computed: {
    /** Stessa barra CTA di Ruote Classiche: prezzo a sinistra, niente descrizione centrale, bottone senza importo duplicato. */
    compactPriceLayout() {
      return this.type === 'ruote-classiche' || this.type === 'storica';
    },
    price() {
      if (this.acquistoCta && this.acquistoCta.labels && this.acquistoCta.labels[this.type]) {
        const t = this.acquistoCta.labels[this.type].text;
        if (t) {
          return t;
        }
      }
      const defaults = {
        nominale: 'QUOTAZIONE NOMINALE',
        'live-market': 'REPORT LIVE MARKET',
        storica: 'QUOTAZIONE STORICA',
        'report-aci': 'REPORT STORICO ACI',
        'ruote-classiche': 'QUOTAZIONE RUOTECLASSICHE',
      };
      return defaults[this.type] || '';
    },
    buttonText() {
      const map = {
        nominale: 'ACQUISTA A ',
        'live-market': 'ACQUISTA A ',
        storica: 'ACQUISTA A ',
        sponsor: 'ACQUISTA A ',
        'report-aci': 'ACQUISTA A ',
        'ruote-classiche': 'ACQUISTA A ',
      };
      return map[this.type] || '';
    },
    /** Prezzo solo a sinistra: niente importo ripetuto nel bottone. */
    mainButtonLabel() {
      if (this.compactPriceLayout) {
        return 'ACQUISTA ORA';
      }
      return this.buttonText;
    },
    showPrice() {
      return !!(this.promotions && this.promotions[this.type]);
    },
    ctaDescription() {
      const labels = this.acquistoCta && this.acquistoCta.labels ? this.acquistoCta.labels : {};
      const current = labels[this.type];
      const fallback = labels.default;
      if (current && current.description) {
        return current.description;
      }
      if (fallback && fallback.description) {
        return fallback.description;
      }
      return '';
    },
    liveMarketDescription() {
      const labels = this.acquistoCta && this.acquistoCta.labels ? this.acquistoCta.labels : {};
      const liveMarket = labels['live-market'];
      const fallback = labels.default;
      if (liveMarket && liveMarket.description) {
        return liveMarket.description;
      }
      if (fallback && fallback.description) {
        return fallback.description;
      }
      return '';
    },
    liveMarketText() {
      const labels = this.acquistoCta && this.acquistoCta.labels ? this.acquistoCta.labels : {};
      const liveMarket = labels['live-market'];
      const fallback = labels.default;
      if (liveMarket && liveMarket.text) {
        return liveMarket.text;
      }
      if (fallback && fallback.text) {
        return fallback.text;
      }
      return '';
    },
  },
  methods: {
    sendTracking(clickEvent) {
      if (
        clickEvent &&
        window &&
        window.webtrekk_funcs &&
        typeof window.webtrekk_funcs.trackWebtrekkEvent === 'function'
      ) {
        window.webtrekk_funcs.trackWebtrekkEvent(clickEvent);
        window.webtrekk_funcs.sendWebtrekkEvents();
      }
    },
    onMainClick(event) {
      this.loadingMain = true;
      const evt = event.currentTarget.dataset.eventClick;
      this.sendTracking(evt);
      this.$emit('submit-form', this.type);
    },
    onLiveMarketClick(event) {
      this.loadingLiveMarket = true;
      const evt = event.currentTarget.dataset.eventClick;
      this.sendTracking(evt);
      this.$emit('submit-form', 'live-market');
    },
    setupViewportTracking() {
      if (!('IntersectionObserver' in window)) {
        return;
      }
      const obs = new IntersectionObserver(
        (entries, o) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const el = entry.target;
              const imps = el.dataset.eventImps;
              this.sendTracking(imps);
              o.unobserve(el);
            }
          });
        },
        { threshold: 0.5 },
      );
      if (this.$refs.liveMarketButton) {
        obs.observe(this.$refs.liveMarketButton);
      }
      if (this.$refs.mainButton) {
        obs.observe(this.$refs.mainButton);
      }
    },
  },
  mounted() {
    this.$nextTick(this.setupViewportTracking);
  },
};
</script>

<style scoped>
.button-primary,
.button-buy-nominal {
  min-width: 199px;
  min-height: 50px;
}

.button-buy-nominal {
  background-color: #ffffff;
  color: #ff66c4;
  box-shadow: 0px 2px 2px #00000029;
  border-radius: 4px;
  border: none;
  padding: 13px 20px;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  font: normal normal 600 16px / 19px Montserrat;
  letter-spacing: 0px;
}
.bg-primary {
  background-color: #009fe3;
}

.button-buy-nominal:hover {
  background-color: #009fe3;
  color: #ffffff;
}

.disabledBtn {
  opacity: 0.65;
  pointer-events: none;
}

.fs-14 {
  font-size: 14px;
}
.mr-45 {
  margin-right: 45px;
}
.line-through {
  text-decoration: line-through;
  text-decoration-thickness: 2px;
  background-color: transparent;
}

.prize-text--prezzo .prezzo-prefix {
  margin-right: 6px;
}

.prize-text--prezzo .prezzo-promo {
  margin-left: 6px;
}

.button-container--compact-price .prize-text--prezzo:empty {
  min-height: 1em;
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/BuyQuotationBtn.vue